import { useCallback, useState } from 'react';
import { UseBreakdownProps } from '../types';

export const useBreakdown = (props: UseBreakdownProps) => {
  const { isExpanded, handleExpand, handleCollapse } = props;
  const [isBreakdownOpen, setIsOpenBreakdown] = useState(isExpanded ?? false);
  const isInternal = isExpanded == null;
  const isOpen = isInternal ? isBreakdownOpen : isExpanded;

  const hideBreakdown = useCallback(() => {
    if (isInternal) {
      setIsOpenBreakdown(false);
    } else if (handleCollapse) {
      handleCollapse();
    }
  }, [handleCollapse, isInternal]);

  const showBreakdown = useCallback(() => {
    if (isInternal) {
      setIsOpenBreakdown(true);
    } else if (handleExpand) {
      handleExpand();
    }
  }, [handleExpand, isInternal]);

  return {
    hideBreakdown,
    isBreakdownOpen: isOpen,
    showBreakdown,
    toggleBreakdown: useCallback(() => {
      if (isOpen) {
        hideBreakdown();
      } else {
        showBreakdown();
      }
    }, [hideBreakdown, isOpen, showBreakdown]),
  };
};
